<template>
  <div class="cpt-tab-block" :class="{ active: isActive, relative: $slots.default, greytext: isGreyText }">
    <ChatImg
      class="img"
      :class="[imgType]"
      v-if="img"
      :src="img"
      :webp_quality="30"
      thumbnail="48x"
    />
    <div v-else-if="icon && icon == 'default-room'" class="default-room" :class="[imgType]">
      <i class="iconfont left icon-room"></i>
    </div>
    <i class="iconfont left" v-else-if="icon" :class="icon"></i>
    <span class="tab-block-text">{{ title }}</span>
    <i class="iconfont icon-arrow-down" v-if="arrow !== undefined" :class="{up: arrow}"></i>
    <i class="iconfont icon-close-bold" @click.stop="$emit('close')" v-if="closeable"></i>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    img: {
      default: '',
    },
    title: {
      default: ''
    },
    isActive: {
      default: false
    },
    icon: {
      default: ''
    },
    arrow: {
      default: undefined
    },
    imgType: {
      default: ''
    },
    closeable: {
      default: false
    },
    isGreyText: {
      default: false
    }
  },
}
</script>

<style lang="scss">
.cpt-tab-block {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $d-op-1;
  border-radius: 4px;
  cursor: pointer;
  padding: 0 10px;
  &:hover {
    background: $d-op-2;
  }
  &.active {
    background: $d-bd-fl;
    & > span, & > .iconfont {
      color: #FFFFFF;
    }
    .img, .default-room {
      position: relative;

      &::after,
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        box-sizing: border-box;
      }

      &::after {
        width: 20px;
        height: 20px;
        border: 2px solid #FFFFFF;
      }

      &::before {
        width: 16px;
        height: 16px;
        border: 2px solid $d-bd-fl;
      }
    }
  }

  &.greytext {
    span {
      color: $d-tx-3;
    }
    i {
      color: $d-tx-3;
    }
  }
  &.relative {
    position: relative;
  }

  .img {
    width: 18px;
    height: 18px;
    margin-right: 6px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .tab-block-text {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.01em;
    color: $d-tx-2;
    padding-bottom: 1px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i{
    color: $ct-wh-0;
    &.left {
      width: 12px;
      height: 12px;
      font-size: 12px;
      margin-right: 3px;
    }
    &.icon-arrow-down {
      width: 6px;
      height: 6px;
      font-size: 12px;
      transform: rotate(-180deg);
      transition: all .15s linear;
      margin-left: 3px;
      color: $d-op-3;
      &::before {
        transform: scale(.5);
        transform-origin: left top;
      }
      &.up {
        transform: rotate(0);
      }
    }
    &.icon-close-bold {
      width: 12px;
      height: 12px;
      font-size: 12px;
      color: $d-tx-2;
      margin-left: 3px;
      cursor: pointer;
    }
  }
  .default-room {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    i {
      background: $d-bd-fl;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      &::before {
        font-size: 20px;
        width: 20px;
        height: 20px;
        transform: scale(.5);
        transform-origin: center;
      }
    }
  }
}
</style>